<script setup>
import axios from '@axios'
import { useAppAbility } from '@/plugins/casl/useAppAbility'
import { useUsersStore } from '@/stores'
import { safeRedirectPath } from '@/utils/safeRedirect'
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()
const ability = useAppAbility()
const usersStore = useUsersStore()

onMounted(async () => {
  const redirect = safeRedirectPath(route.query.redirect) || '/membership'

  // RM-420 (10/22): the session comes in the auth cookie the sign-in link set, never in this
  // page's address; the page trades it for the token it keeps (POST /auth/session-token).
  // A link opened before that change still carries ?jwt= - read once, for this release.
  let jwtToken = route.query.jwt
  if (!jwtToken) {
    try {
      const res = await axios.post('/auth/session-token')

      jwtToken = res.data && res.data.token
    } catch (e) {
      jwtToken = null
    }
  }

  if (!jwtToken) {
    router.replace('/home/login')

    return
  }

  // Store auth data in localStorage
  localStorage.setItem('accessToken', JSON.stringify(jwtToken))
  localStorage.setItem('jwt', JSON.stringify(jwtToken))

  // Fetch user data with the new token
  try {
    await usersStore.getMyUser()
    const myUser = usersStore.myUser
    if (myUser) {
      localStorage.setItem('userData', JSON.stringify(myUser))
      localStorage.setItem('userAbilities', JSON.stringify(myUser.abilities))
      ability.update(myUser.abilities || [])
    }
  } catch (e) {
    console.error('Failed to fetch user after one-time login:', e)
  }

  router.replace(redirect)
})
</script>

<template>
  <div
    class="d-flex align-center justify-center"
    style="min-height: 50vh;"
  >
    <VProgressCircular
      indeterminate
      color="primary"
    />
  </div>
</template>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
